import styled, { css } from 'styled-components'

export const ContainerBox = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	min-width: auto;
	margin-left: 24px;
	height: 90px;
	gap: 20px;

	.user-name-btn {
		font-style: normal;
		font-weight: 400;
		height: 30px;
		font-size: 16px;
		line-height: 20px;
		letter-spacing: 0.3px;
		min-width: 50px;
		cursor: pointer;
		text-align: right;
		gap: 9px;

		color: ${({ theme }) => theme.colors.content.veryDark};
		display: flex;
		justify-content: flex-end;
		align-items: center;

		.user-avatar-acc {
			width: 32px;
			height: 32px;
			margin-left: 13px;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		svg {
			fill: initial;
			height: 20px;
			width: 20px;
		}

		.user-info {
			${({ theme }) => theme.typography.p1};
			min-width: 100px;
			max-width: 150px;
			overflow: hidden;
			text-transform: capitalize;
			white-space: nowrap;
			text-overflow: ellipsis;
			display: block;
			text-align: left;
		}
	}
	.MuiButton-containedPrimary:hover {
		background-color: transparent !important;
	}
`

export const userBoxStyle = css`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 12px;

	.user-avatar-acc {
		width: 60px;
		height: 60px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.context {
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.user-name {
		font-size: 14px;
		font-weight: 500;
		line-height: 18px;
		letter-spacing: 0.2px;
		color: ${({ theme }) => theme.colors.background.element.veryDark};
	}
	.onboard-link {
		font-size: 12px;
		color: #333335;
		font-weight: 500;
		line-height: 16px;
		letter-spacing: 0.1px;
	}
	.percentage-numb {
		padding-left: 5px;
		color: ${({ theme }) => theme.colors.background.element.veryDark};
	}
	svg {
		fill: transparent;
	}
`

export const logoutBoxStyle = css`
	display: flex;
	padding: 1rem;
	gap: 8px;
	cursor: pointer;
`
